import { render } from "./SingleWorkplace.vue?vue&type=template&id=76758177&scoped=true"
import script from "./SingleWorkplace.vue?vue&type=script&lang=js"
export * from "./SingleWorkplace.vue?vue&type=script&lang=js"

import "./SingleWorkplace.vue?vue&type=style&index=0&id=76758177&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76758177"]])

export default __exports__